import { PayrollReportDeviationsFileViewModel } from '@fora-monorepo/employer-my-pages-common/types';

export const mockPayrollReportDeviationsFile: PayrollReportDeviationsFileViewModel = {
  base64EncodedFile:
    'IklELW51bW1lciIsIkbDtnJuYW1uIiwiRWZ0ZXJuYW1uIiwiUGVyaW9kIiwiTMO2biIsIkjDpG5mw7ZybGlnIGzDtm4iCiIxMjEyMTIxMjEyMTIiLCJUZXN0IiwiVGVzdHNzb24iLCIyMDIzMDEiLDk5OTksIjIwMjIxMjogMTAwMCwgMjAyMjExOiAxMDAwIg==',
};
